import { render } from "./Dashboard.vue?vue&type=template&id=0208c926&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=0208c926&scoped=true&lang=css"
import "./Dashboard.vue?vue&type=style&index=1&id=0208c926&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0208c926"]])

export default __exports__